module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-800.woff?05ebdbe10796850f045fcd484f35788d";